import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useTemplatesStudio } from 'api/useTemplatesStudio';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { EToasterStatus, showToast } from 'utils/showToast';

import DialogModal from 'components/DialogModal/DialogModal';

export const TemplatesStudioActivateDialog: React.FC = () => {
  const { publisherId } = useParams();
  const { activateTemplate } = useTemplatesStudio(publisherId);
  const { templateIdToActivate, setTemplateIdToActivate } =
    useTemplateStudioState();

  const handleActivate = () => {
    activateTemplate.mutate(
      { templateId: templateIdToActivate! },
      {
        onSuccess: () => {
          showToast({
            message: 'Template activated successfully',
            status: EToasterStatus.SUCCESS
          });
        },
        onError: () => {
          showToast({
            message: 'Error activating template',
            status: EToasterStatus.ERROR
          });
        },
        onSettled: () => {
          setTemplateIdToActivate(undefined);
        }
      }
    );
  };

  return (
    <DialogModal
      isOpen={true}
      onOpenChange={(open: boolean) => {
        if (!open) setTemplateIdToActivate(undefined);
      }}
      title={'Activate Template'}
      description={
        'Activating this template will overwrite your current store design. You can revert to the previous template later if needed.'
      }
      modalActions={{
        onConfirm: { label: 'Activate', action: () => handleActivate() },
        onClose: {
          label: 'Cancel',
          action: () => setTemplateIdToActivate(undefined),
          variant: 'link'
        }
      }}
    />
  );
};
